import React, { useState } from 'react';
import { Button } from '../base/Button';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/903323028232?text=Merhaba, İSG hizmetleriniz hakkında bilgi almak istiyorum.', '_blank');
  };

  const handleTeklifClick = (e: React.MouseEvent) => {
    e.preventDefault();
    handleWhatsAppClick();
  };

  const handlePhoneClick = () => {
    window.open('tel:+903323028232', '_self');
  };

  const handleEmailClick = () => {
    window.open('mailto:bilgi@ozgurisg.net', '_self');
  };

  return (
    <>
      {/* Top Contact Bar */}
      <div className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-end py-2 space-x-6">
            <div className="flex items-center space-x-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-green-600 text-sm"></i>
              </div>
              <a 
                href="tel:+903323028232" 
                onClick={handlePhoneClick}
                className="text-gray-800 hover:text-green-600 text-sm font-medium cursor-pointer"
              >
                0332 302 82 32
              </a>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-mail-line text-green-600 text-sm"></i>
              </div>
              <a 
                href="mailto:bilgi@ozgurisg.net" 
                onClick={handleEmailClick}
                className="text-gray-800 hover:text-green-600 text-sm font-medium cursor-pointer"
              >
                bilgi@ozgurisg.net
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className="bg-white shadow-lg sticky top-0 z-50">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <div className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/2b1409af55cbbc24ae624602859a344f/58604aa41f714b3c9b4f8b0389bc6614.png" 
                alt="Özgür Osgb - İş Sağlığı ve Güvenliği" 
                className="h-12 w-auto"
              />
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              <a href="/" className="text-gray-700 hover:text-blue-600 font-medium whitespace-nowrap cursor-pointer">Ana Sayfa</a>
              <a href="/hakkimizda" className="text-gray-700 hover:text-blue-600 font-medium whitespace-nowrap cursor-pointer">Hakkımızda</a>
              <a href="/hizmetler" className="text-gray-700 hover:text-blue-600 font-medium whitespace-nowrap cursor-pointer">Hizmetler</a>
              <a href="/iletisim" className="text-gray-700 hover:text-blue-600 font-medium whitespace-nowrap cursor-pointer">İletişim</a>
              <Button 
                onClick={handleTeklifClick}
                className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-medium whitespace-nowrap cursor-pointer"
              >
                Ücretsiz Teklif Al
              </Button>
            </nav>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg hover:bg-gray-100 cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl text-gray-700`}></i>
              </div>
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="md:hidden py-4 border-t border-gray-200">
              <nav className="flex flex-col space-y-4">
                <a href="/" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">Ana Sayfa</a>
                <a href="/hakkimizda" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">Hakkımızda</a>
                <a href="/hizmetler" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">Hizmetler</a>
                <a href="/iletisim" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">İletişim</a>
                <Button 
                  onClick={handleTeklifClick}
                  className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-medium w-fit whitespace-nowrap cursor-pointer"
                >
                  Ücretsiz Teklif Al
                </Button>
              </nav>
            </div>
          )}
        </div>
      </header>
    </>
  );
};